'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _paths2 = require('../feiseanna/paths');

var _index = require('./index');

var _getRegistrations = require('../registrations/getRegistrations');

var _getRegistrations2 = _interopRequireDefault(_getRegistrations);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (sid, fid) {
  return function (dispatch, getState) {
    var promise = Promise.resolve();
    var schoolStudents = (0, _paths.getSchoolCompetitors)(getState(), sid);

    if (!schoolStudents || !(schoolStudents.every(function (pid) {
      return (0, _paths2.getFlagsForPerson)(getState(), fid, pid);
    }).size > 0)) {
      promise = dispatch((0, _index.getCompetitorsForSchool)(sid, fid));
    }

    return promise.then(function () {
      return (0, _paths.getSchoolCompetitors)(getState(), sid).filter(function (pid) {
        return (0, _paths2.getFlagsForPerson)(getState(), fid, pid).getIn(['registered']);
      }).map(function (pid) {
        return dispatch((0, _getRegistrations2.default)(fid, pid));
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/schools/getRegistrations.js
// module id = 669
// module chunks = 0